import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { JSONApiDataObject, ReduxEntity, ReviewResponseModel } from 'Douleutaras/types';
import { RootState } from 'Douleutaras/redux/store';

const feedbackResponseAdapter = createEntityAdapter<JSONApiDataObject<ReviewResponseModel>>({
  selectId: item => item.id
});

export const feedbackResponseSlice = createSlice({
  name: 'feedbackResponse',
  initialState: feedbackResponseAdapter.getInitialState({
    loading: false,
    error: false,
    meta: {},
    entities: {}
  } as ReduxEntity<JSONApiDataObject<ReviewResponseModel>>),
  reducers: {
    feedbackResponseAdded: (state, action) => {
      feedbackResponseAdapter.setMany(state, action.payload);
    }
  }
});

export const { feedbackResponseAdded } = feedbackResponseSlice.actions;
export const feedbackResponseSelectors = feedbackResponseAdapter.getSelectors((state: RootState) => state.feedbackResponse);
